import { defineComponent as j, computed as r, ref as N, watch as q, openBlock as v, createElementBlock as S, createElementVNode as p, normalizeClass as E, toDisplayString as h, mergeProps as G, withModifiers as H, createVNode as J, unref as K, createCommentVNode as D, createBlock as z, withCtx as Q } from "vue";
import ee from "../../icons/generated/IconPlus.vue2.js";
import { isEmpty as f } from "../../utils/isEmpty.js";
import { tw as t } from "../../utils/tailwind.js";
import te from "../Document/Document.vue2.js";
import ae from "../DocumentList/DocumentList.vue2.js";
import { IMAGE_FILE_PREVIEW_EXTENSIONS as le, ERROR_EVENT as ie } from "./InputFileUpload.constant.js";
import { hasValidExtension as T, getTotalFilesSize as re } from "./InputFileUpload.helpers.js";
const oe = { class: "group relative h-48" }, se = ["for"], ne = ["id", "accept", "disabled", "multiple"], ue = ["id", "role"], Fe = /* @__PURE__ */ j({
  name: "RevInputFileUpload",
  inheritAttrs: !1,
  __name: "InputFileUpload",
  props: {
    modelValue: { default: () => [] },
    accept: { default: () => ["*"] },
    deleteAlternativeText: { default: "" },
    description: { default: "" },
    disabled: { type: Boolean, default: () => !1 },
    id: {},
    errors: { default: () => [] },
    labelEmpty: {},
    labelNotEmpty: { default: "" },
    maxFiles: { default: Number.POSITIVE_INFINITY },
    maxFileSize: { default: Number.POSITIVE_INFINITY },
    maxFilesSize: { default: Number.POSITIVE_INFINITY },
    minFileSize: { default: 0 },
    disableImagePreview: { type: Boolean, default: !1 },
    filePreviewDisplay: { default: "inline" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["errors", "update:modelValue"],
  setup(c, { emit: C }) {
    const e = c, b = C, A = r(() => !f(e.modelValue)), P = r(() => A.value && !f(e.labelNotEmpty) ? e.labelNotEmpty : e.labelEmpty), M = r(() => e.accept.join()), R = r(() => !f(e.description)), u = r(() => !f(e.errors)), $ = r(() => {
      if (u.value)
        return `${e.id}_error`;
    }), m = N([]);
    function k(i) {
      return new Promise((n, l) => {
        const a = new FileReader();
        a.onload = () => n(a.result), a.onerror = () => l(new Error(`Failed to read file: ${i.name}`)), a.readAsDataURL(i);
      });
    }
    q(
      () => e.modelValue,
      async (i) => {
        if (!i || !i.length) {
          m.value = [];
          return;
        }
        try {
          const n = await Promise.all(
            i.map(async (l, a) => ({
              file: l,
              previewUrl: await k(l),
              isImage: T(l, le),
              key: `${l.name}_${l.size}_${a}`
            }))
          );
          m.value = n;
        } catch {
          m.value = [];
        }
      },
      { immediate: !0 }
    );
    const O = r(() => e.modelValue ? e.modelValue.length >= e.maxFiles : !1), o = r(() => e.disabled || O.value), X = r(() => [
      t`body-2 mt-8`,
      !u.value && !o.value && t`text-static-default-low`,
      u.value && !o.value && t`text-static-danger-hi`,
      o.value && t`text-static-default-low-disabled`
    ]), L = r(() => [
      t`peer body-1 absolute inset-0 items-center py-12 pl-12 pr-52`,
      /* In case of a lengthy label, hide the rest of the label under an ellipsis. */
      t`inline max-w-full truncate`,
      o.value ? t`text-action-default-hi-disabled cursor-default` : t`text-action-default-hi cursor-pointer`
    ]), U = r(() => [
      t`rounded-sm flex size-full items-center justify-end`,
      t`motion-safe:transition-colors motion-safe:duration-200`,
      !o.value && t`bg-static-default-low peer-hover:bg-static-default-low-hover`,
      o.value && t`bg-static-default-low-disabled`
    ]), B = r(() => [
      t`pointer-events-none absolute inset-0 rounded-sm border border-solid`,
      t`motion-safe:transition-colors motion-safe:duration-200`,
      o.value && t`border-action-default-low-disabled`,
      !u.value && !o.value && t`border-action-default-low group-focus-within:border-action-default-low-pressed group-focus-within:border-retina`,
      u.value && !o.value && t`border-action-danger-low group-focus-within:border-action-danger-low-pressed group-focus-within:border-retina`
    ]), W = r(() => e.maxFiles > 1), F = N(null);
    function Y(i) {
      const l = i.target.files, a = [];
      let d = [...e.modelValue];
      Array.from(l).forEach((s) => {
        const I = re([...d, s]), w = I <= e.maxFilesSize;
        w || a.push({
          meta: { totalFilesSize: I },
          type: "MAX_FILES_SIZE_EXCEEDED"
        });
        const y = d.length < e.maxFiles;
        y || a.push({
          meta: { filename: s.name },
          type: "MAX_FILES_EXCEEDED"
        });
        const x = s.size < e.maxFileSize;
        x || a.push({
          meta: { filename: s.name },
          type: "MAX_FILE_SIZE_EXCEEDED"
        });
        const V = e.minFileSize < s.size;
        V || a.push({
          meta: { filename: s.name },
          type: "MIN_FILE_SIZE_NOT_EXCEEDED"
        });
        const g = T(s, e.accept);
        g || a.push({
          meta: { filename: s.name },
          type: "WRONG_FILE_EXTENSION"
        }), w && y && x && V && g && (d = [...d, s]);
      }), f(a) || b(ie, a), b("update:modelValue", d);
      const _ = F.value;
      _ && (_.value = "");
    }
    function Z(i) {
      const n = [
        ...e.modelValue.slice(0, i),
        ...e.modelValue.slice(i + 1)
      ];
      b("update:modelValue", n);
    }
    return (i, n) => (v(), S("div", null, [
      p("div", oe, [
        p("div", {
          "aria-hidden": "true",
          class: E(B.value)
        }, null, 2),
        p("label", {
          class: E(L.value),
          for: c.id
        }, h(P.value) + h(c.required ? " *" : ""), 11, se),
        p("div", {
          class: E(U.value)
        }, [
          p("input", G(i.$attrs, {
            id: c.id,
            ref_key: "input",
            ref: F,
            accept: M.value,
            class: "peer absolute z-[-1] opacity-0",
            disabled: o.value,
            multiple: W.value,
            type: "file",
            onChange: H(Y, ["prevent"])
          }), null, 16, ne),
          J(K(ee), {
            "aria-hidden": "true",
            class: "text-static-default-low ml-16 mr-12 h-32 peer-disabled:text-static-default-low-disabled"
          })
        ], 2)
      ]),
      R.value ? (v(), S("p", {
        key: 0,
        id: $.value,
        "aria-live": "assertive",
        class: E(X.value),
        role: u.value ? "alert" : "presentation"
      }, h(c.description), 11, ue)) : D("", !0),
      m.value.length ? (v(), z(ae, {
        key: 1,
        class: "max-w-[912px]",
        documents: m.value,
        variant: e.filePreviewDisplay
      }, {
        item: Q(({ document: l, index: a }) => [
          (v(), z(te, {
            key: l.key,
            deletable: "",
            "delete-button-aria-label": e.deleteAlternativeText,
            name: l.file.name,
            thumbnail: l.isImage && !e.disableImagePreview,
            url: l.previewUrl,
            onDelete: (d) => Z(a)
          }, null, 8, ["delete-button-aria-label", "name", "thumbnail", "url", "onDelete"]))
        ]),
        _: 1
      }, 8, ["documents", "variant"])) : D("", !0)
    ]));
  }
});
export {
  Fe as default
};
